import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  ButtonGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { appendPathToClientUrl } from 'services/helpers/resolveApiBaseUrl';

import BreadCrumb from 'Components/Common/BreadCrumb';
import DeleteModal from 'Components/Common/DeleteModal';
// Export Modal
import ExportCSVModal from 'Components/Common/ExportCSVModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import {
  // GetAllProductsFromAPI,
  GetAllProductsLightGroupByItemIdNumberFromAPI,
  GetAllProductsRow,
  GetProductLightByIdFromAPI,
  ProductSearchFilters,
  // ProductsGroupedByStore,
} from 'types/productTypes';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'slices';
// import { createSortableHeader } from 'Components/pos2u/CreateSortableHeader';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import {
  deleteBulkProductsByItemIdNumber,
  getCheckComposite,
  // getExportProductsInfoGroupedByStore,
  getExportProductsInformation,
  getExportProductsQuantity,
  getProductPricesById,
  getSearchProductsLight,
  postProductsSimple,
  getSearchProductPaginationIdsFromES,
  ProductESSearchParams,
  // getSearchProductsList,
  // getSearchProductsListV2,
} from 'services/productService';
import { FaBarcode, FaImage, FaListAlt, FaListUl } from 'react-icons/fa';
import styles from 'pages/Products/styles/products.module.css';
import {
  DISPLAY_IMAGE_SIZE,
  getProductColumnWidth,
  ProductListActionButtons,
  ProductListButtonIconSize,
  TextColumnsStyle,
} from 'pages/Products/ProductConstants';
import { transformArrayToStr } from 'utils/common/handleSelect';
import ModalBackdropError from 'Components/pos2u/ModalBackdropError';
import ColumnSelectionModal from 'Components/pos2u/ColumnSelectionModal';
import { ImageWithFallback } from 'Components/pos2u/ImageWithFallback';
import { useDispatch } from 'react-redux';
import {
  clearSearchListCache,
  setActivePriceIndex,
  setCurrentPage,
  setEntriesPerPage,
  setInputPageValue,
  setPageFilters,
  setPriceEditKey,
  setPriceModalOpen,
  setPriceValues,
  setSearchListCache,
} from 'slices/product/form/reducer';
import { MdCurrencyExchange, MdMoveToInbox } from 'react-icons/md';
import { FaRegPenToSquare } from 'react-icons/fa6';
import PricesModal from 'pages/Products/PricesModal/PricesModal';
import { formatNumberWithCommas } from 'utils/maths/Str2Num';
import { ITEMS } from 'Routes/constants';
import {
  setActiveInventoryDetailsIndex,
  setActiveInventoryIndex,
  setInventoryDetailsEditKey,
  setInventoryDetailsModalOpen,
  setInventoryDetailsValues,
  setInventoryEditKey,
  setInventoryModalOpen,
  setInventoryValues,
} from 'slices/productInventory/reducer';
import InventoryModal from './InventoryModal';
import InventoryDetailsModal from './InventoryDetailsModal';
import ExportButton from './ProductsExport/ExportButton';
import { exportProductInformationExcel } from 'Components/pos2u/Excel/exportProductInformation';
import {
  EXPORT_LIMIT,
  RETRIEVE_LIMIT,
} from 'pages/Products/ProductsExport/constants';
import { exportProductQuantityExcel } from 'Components/pos2u/Excel/exportProductQuantity';
import LoaderModal from 'Components/pos2u/Modals/LoaderModal';
import { truncateText_v2 } from 'utils/common/String';
import useWindowSize from 'Components/Hooks/WindowSizeHook';
import ProductExportModal from 'pages/Products/ProductsExport/ProductExportModal';
import ProductQuantityExportModal from 'pages/Products/ProductsExport/ProductExportModal';
import { setProductExportFilters } from 'slices/exportData/reducer';
import { ExportRange } from 'types/common/Range';
import MainAddButton from 'Components/pos2u/Buttons/MainAddButton';
import IconActionButton from 'Components/pos2u/Buttons/IconActionButton';
import ProductSearchForm from './ProductSearchForm';
import TextSelectedItems from 'Components/pos2u/TextSelectedItems';
import TableWrapper from 'Components/pos2u/TableWrapper';
import MainDeleteButton from 'Components/pos2u/Buttons/MainDeleteButton';

// import useWindowSize from 'Components/Hooks/WindowSizeHook';

const ItemsPage = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const dispatch = useDispatch();
  const productURI = useMemo(() => ITEMS.LIST, []);
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const MinHeightStyle = useMemo(() => ({ minHeight: '30px' }), []);

  // const { width } = useWindowSize();

  // const layoutState = useSelector((state: RootState) => state.Layout);
  // const { layoutModeType } = layoutState;

  const { layoutModeType } = useSelector(
    (state: RootState) => ({
      layoutModeType: state.Layout.layoutModeType,
    }),
    shallowEqual
  );
  const isDarkMode = layoutModeType === 'dark';

  // const infoState = useSelector((state: RootState) => state.Info);
  // const { branches, isBranchesLoaded, branchCodes } = infoState;

  const { branches, isBranchesLoaded, branchCodes } = useSelector(
    (state: RootState) => ({
      branches: state.Info.branches,
      isBranchesLoaded: state.Info.isBranchesLoaded,
      branchCodes: state.Info.branchCodes,
    }),
    shallowEqual
  );

  // const exportDataState = useSelector((state: RootState) => state.ExportData);
  // const { StoresTextMap } = exportDataState;

  const { StoresTextMap } = useSelector(
    (state: RootState) => ({
      StoresTextMap: state.ExportData.StoresTextMap,
    }),
    shallowEqual
  );

  const { PageFilters, PageDetails, pageConfig, searchListCache } = useSelector(
    (state: RootState) => ({
      PageFilters: state.Product.form.PageFilters,
      PageDetails: state.Product.form.PageDetails,
      pageConfig: state.Product.form.pageConfig,
      searchListCache: state.Product.form.searchListCache,
    }),
    shallowEqual
  );
  const rawCategories = useSelector(
    (state: RootState) => state.Product.select.rawCategories
  );
  // const productState = useSelector((state: RootState) => state.Product);
  // const { PageFilters, PageDetails, productFormDetails } = productState;

  const [isExportCSV, setIsExportCSV] = useState<boolean>(false);
  // const columnHelper = createColumnHelper<GetProductByIdFromAPI>();
  const columnHelper = createColumnHelper<GetAllProductsRow>();

  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  // const [productList, setProductList] = useState<GetAllProductsFromAPI[]>([]);
  // const [productList, setProductList] = useState<GetProductByIdFromAPI[]>([]);
  const [productList, setProductList] = useState<
    GetAllProductsLightGroupByItemIdNumberFromAPI[]
  >(searchListCache.productList);
  // const [productList, setProductList] = useState<
  //   GetAllProductsGroupByItemIdNumberFromAPI[]
  // >([]);
  // const [rowProducts, setRowProducts] = useState<GetAllProductsRow[]>([]);
  const [isLoaderModalOpen, setIsLoaderModalOpen] = useState(false);
  const [loaderError, setLoaderError] = useState('');

  const [productTotal, setProductTotal] = useState<number>(
    searchListCache.productTotal
  );
  const [isLoadSuccess, setIsLoadSuccess] = useState<boolean>(false);
  const [latestSearchItemIds, setLatestSearchItemIds] = useState<string[] | null>(
    searchListCache.latestSearchItemIds
  );

  const [isAdvanceSearch, setIsAdvanceSearch] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState<string[]>([
    '#',
    'images',
    'code',
    'tags',
    'barcode',
    'category_name',
    'name',
    'cost_price',
    'unit_price',
    'quantity',
    'store_id',
    'action',
  ]);

  const branchesIds = useMemo(
    () => branches.map((branch) => branch.value.toString()),
    [branches]
  );
  const currentSearchCacheKey = useMemo(() => {
    // When quantity/tag filters are active, fetchAllProducts uses getSearchProductsLight
    // with all PageFilters directly — include full filters in cache key.
    // Otherwise it uses the ES path (latestSearchItemIds), where productName/barcode/code/
    // category/supplier are already captured by latestSearchItemIds, so excluding them
    // prevents a duplicate fetch when form submit updates PageFilters after ES already fired.
    const hasUnsupportedSimpleFilters =
      (PageFilters.quantityMin !== '' && PageFilters.quantityMax !== '') ||
      PageFilters.tag_ids.length > 0;

    return JSON.stringify(
      hasUnsupportedSimpleFilters
        ? {
            filters: PageFilters,
            page: PageDetails.currentPage,
            limit: PageDetails.entriesPerPage,
            latestSearchItemIds,
            branchesIds,
          }
        : {
            branch: PageFilters.branch,
            page: PageDetails.currentPage,
            limit: PageDetails.entriesPerPage,
            latestSearchItemIds,
            branchesIds,
          }
    );
  }, [PageDetails.currentPage, PageDetails.entriesPerPage, PageFilters, latestSearchItemIds, branchesIds]);
  const hasUsedInitialCacheRef = useRef(false);
  const shouldHydrateFromCache =
    searchListCache.cacheKey === currentSearchCacheKey;
  const cacheHydrationDelayMs = 180;

  const AllColumn = useMemo(
    () => [
      { id: '#', name: 'ID' },
      { id: 'images', name: t('ProductPage_Items') },
      { id: 'code', name: t('ProductPage_Code') },
      { id: 'tags', name: t('Tags') },
      { id: 'barcode', name: t('ProductField_BarcodeID') },
      { id: 'store_id', name: t('Branch') },
      // { id: 'category_name', name: t('ProductField_Category') },
      // { id: 'name', name: t('ProductField_ItemName') },
      { id: 'cost_price', name: t('ProductField_CostPrice') },
      { id: 'unit_price', name: t('ProductField_UnitPrice') },
      { id: 'quantity', name: t('ProductPage_QuantityBalance') },
      { id: 'action', name: 'Action' },
    ],
    [t]
  );

  const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);

  const toggleColumnModal = () => {
    setIsColumnModalOpen((prev) => !prev);
  };

  const handleColumnVisibilityChange = (
    columnId: string,
    isChecked: boolean
  ) => {
    setVisibleColumns((prev) =>
      isChecked ? [...prev, columnId] : prev.filter((id) => id !== columnId)
    );
  };

  const [exportProductInformationModal, setExportProductInformationModal] =
    useState<boolean>(false);

  const [exportProductQuantityModal, setExportProductQuantityModal] =
    useState<boolean>(false);

  // const fetchExportProductsQuantity = useCallback(async () => {
  //   if (productTotal * PageFilters.branch.length > EXPORT_LIMIT) return;
  //   if (!isBranchesLoaded) return;
  //   setIsLoadSuccess(false);
  //   try {
  //     const rs = await getExportProductsQuantity(
  //       PageFilters.branch && PageFilters.branch.length === 0
  //         ? `[${transformArrayToStr(branchesIds)}]`
  //         : `[${transformArrayToStr(PageFilters.branch)}]`,
  //       PageFilters.productName,
  //       productTotal,
  //       PageDetails.currentPage + 1,
  //       PageFilters.category,
  //       PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
  //         ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
  //         : '',
  //       PageFilters.barcode,
  //       PageFilters.supplier
  //     );

  //     if (rs) {
  //       const { message, error_code, data } = rs;

  //       if (message === 'OK' && error_code === 0) {
  //         const { products } = data;

  //         setProductExportQuantity(products);
  //       }
  //     }
  //     setIsLoadSuccess(true);
  //   } catch (error) {
  //     console.error('Failed to fetch all products:', error);
  //     if (typeof error === 'string' && error.includes('Validation error: ')) {
  //       const jsonObj = JSON.parse(error.replace('Validation error: ', ''));
  //       console.log(jsonObj);
  //       const txtError = jsonObj[0].msg ? jsonObj[0].msg : 'Validation error';

  //       setErrorMsg(txtError);
  //     } else {
  //       setErrorMsg(`Failed to fetch all products: ${error}`);
  //     }
  //     setIsLoadSuccess(true);
  //     setIsError(true);
  //   }
  // }, [
  //   productTotal,
  //   PageDetails.currentPage,
  //   PageFilters.productName,
  //   PageFilters.branch,
  //   PageFilters.category,
  //   PageFilters.quantityMin,
  //   PageFilters.quantityMax,
  //   PageFilters.barcode,
  //   PageFilters.supplier,
  //   branchesIds,
  //   isBranchesLoaded,
  // ]);

  // const fetchExportProductsQuantity = useCallback(
  //   async (exportRange: ExportRange) => {
  //     // if (productTotal * PageFilters.branch.length > EXPORT_LIMIT) return;
  //     const exportDataReqAmount =
  //       parseInt(exportRange.end) - parseInt(exportRange.start) + 1;
  //     if (exportDataReqAmount > EXPORT_LIMIT) return;
  //     if (!isBranchesLoaded) return;
  //     setIsLoaderModalOpen(true);

  //     try {
  //       const allProducts: any[] = [];
  //       const limit = RETRIEVE_LIMIT;
  //       // const totalPages = Math.ceil(productTotal / limit);
  //       const totalReqests = Math.ceil(exportDataReqAmount / limit);

  //       for (
  //         let page = 1, offset = 0;
  //         page <= totalReqests;
  //         page++, offset += exportDataReqAmount
  //       ) {
  //         const rs = await getExportProductsQuantity(
  //           PageFilters.branch.length === 0
  //             ? `[${transformArrayToStr(branchesIds)}]`
  //             : `[${transformArrayToStr(PageFilters.branch)}]`,
  //           PageFilters.productName,
  //           exportRange.start + offset,
  //           exportRange.end + offset,
  //           PageFilters.category,
  //           PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
  //             ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
  //             : '',
  //           PageFilters.barcode,
  //           PageFilters.supplier
  //         );

  //         if (rs?.message === 'OK' && rs.error_code === 0) {
  //           allProducts.push(...rs.data.products);
  //         } else {
  //           console.warn(`Page ${page} failed or returned no data`);
  //         }
  //       }
  //       console.log('allProducts');
  //       console.log(allProducts);
  //       await exportProductQuantityExcel(
  //         t,
  //         allProducts,
  //         StoresTextMap,
  //         PageFilters.branch
  //       );

  //       setIsLoaderModalOpen(false);
  //     } catch (error) {
  //       console.error('Failed to fetch all products:', error);
  //       setErrorMsg(`Export failed: ${error}`);
  //       setIsLoaderModalOpen(false);
  //       setIsError(true);
  //       setLoaderError(`Export failed: ${error}`);
  //     }
  //   },
  //   [
  //     t,
  //     // productTotal,
  //     PageFilters.productName,
  //     PageFilters.branch,
  //     PageFilters.category,
  //     PageFilters.quantityMin,
  //     PageFilters.quantityMax,
  //     PageFilters.barcode,
  //     PageFilters.supplier,
  //     branchesIds,
  //     isBranchesLoaded,
  //     StoresTextMap,
  //   ]
  // );

  const fetchExportProductsQuantity = useCallback(
    async (exportRange: ExportRange) => {
      setExportProductQuantityModal(false);
      const start = parseInt(exportRange.start);
      const end = parseInt(exportRange.end);
      const limit = RETRIEVE_LIMIT;

      if (!isBranchesLoaded) return;

      const exportDataReqAmount = end - start + 1;

      // prevent exceeding actual total available products
      const totalFetchAmount = Math.min(exportDataReqAmount, productTotal);

      if (totalFetchAmount > EXPORT_LIMIT) {
        setErrorMsg(`Cannot export more than ${EXPORT_LIMIT} rows at once`);
        setIsError(true);
        return;
      }

      setIsLoaderModalOpen(true);

      try {
        const allProducts: any[] = [];

        for (let offset = 0; offset < totalFetchAmount; offset += limit) {
          const sliceStart = start + offset;
          let sliceEnd = sliceStart + limit - 1;

          // clamp the sliceEnd to the desired user-end and productTotal
          sliceEnd = Math.min(sliceEnd, end, start + totalFetchAmount - 1);

          const rs = await getExportProductsQuantity(
            PageFilters.branch.length === 0
              ? `[${transformArrayToStr(branchesIds)}]`
              : `[${transformArrayToStr(PageFilters.branch)}]`,
            PageFilters.productName,
            sliceStart,
            sliceEnd,
            PageFilters.category,
            PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
              ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
              : '',
            PageFilters.barcode,
            PageFilters.supplier
          );

          if (rs?.message === 'OK' && rs.error_code === 0) {
            allProducts.push(...rs.data.products);
          } else {
            console.warn(`Fetch failed for range ${sliceStart}-${sliceEnd}`);
          }
        }

        await exportProductQuantityExcel(
          t,
          allProducts,
          StoresTextMap,
          PageFilters.branch
        );
        setIsLoaderModalOpen(false);
      } catch (error) {
        console.error('Failed to export products:', error);
        setErrorMsg(`Export failed: ${error}`);
        setIsError(true);
        setLoaderError(`Export failed: ${error}`);
        setIsLoaderModalOpen(false);
      }
    },
    [
      t,
      productTotal,
      PageFilters.productName,
      PageFilters.branch,
      PageFilters.category,
      PageFilters.quantityMin,
      PageFilters.quantityMax,
      PageFilters.barcode,
      PageFilters.supplier,
      branchesIds,
      isBranchesLoaded,
      StoresTextMap,
    ]
  );

  //* ====== Export Products Information ======

  // const fetchExportProductsInformation = useCallback(
  //   async (exportRange: ExportRange) => {
  //     const exportDataReqAmount =
  //       parseInt(exportRange.end) - parseInt(exportRange.start) + 1;
  //     if (exportDataReqAmount > EXPORT_LIMIT) return;
  //     // if (productTotal * PageFilters.branch.length > EXPORT_LIMIT) return;
  //     if (!isBranchesLoaded) return;
  //     setIsLoaderModalOpen(true);

  //     try {
  //       const allProducts: any[] = [];
  //       const limit = RETRIEVE_LIMIT;
  //       // const totalPages = Math.ceil(productTotal / limit);

  //       const totalPages = Math.ceil(exportDataReqAmount / limit);

  //       for (let page = 1; page <= totalPages; page++) {
  //         const rs = await getExportProductsInformation(
  //           PageFilters.branch.length === 0
  //             ? `[${transformArrayToStr(branchesIds)}]`
  //             : `[${transformArrayToStr(PageFilters.branch)}]`,
  //           PageFilters.productName,
  //           exportRange.start,
  //           exportRange.end,
  //           PageFilters.category,
  //           PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
  //             ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
  //             : '',
  //           PageFilters.barcode,
  //           PageFilters.supplier
  //         );

  //         if (rs?.message === 'OK' && rs.error_code === 0) {
  //           allProducts.push(...rs.data.products);
  //         } else {
  //           console.warn(`Page ${page} failed or returned no data`);
  //         }
  //       }
  //       console.log(`allProducts`);
  //       console.log(allProducts);

  //       // setProductExportInformation(allProducts);
  //       // // 👇 Now pass `allProducts` to your ExcelJS function
  //       await exportProductInformationExcel(
  //         t,
  //         allProducts,
  //         StoresTextMap,
  //         productFormDetails.pageConfig.group_price
  //       );

  //       setIsLoaderModalOpen(false);
  //     } catch (error) {
  //       console.log('errorrrrr');
  //       console.log(error);
  //       console.error('Failed to fetch all products:', error);
  //       setErrorMsg(`Export failed: ${error}`);
  //       setIsLoaderModalOpen(false);
  //       setIsError(true);
  //       setLoaderError(`Export failed: ${error}`);
  //     }
  //   },
  //   [
  //     // productTotal,
  //     PageFilters.productName,
  //     PageFilters.branch,
  //     PageFilters.category,
  //     PageFilters.quantityMin,
  //     PageFilters.quantityMax,
  //     PageFilters.barcode,
  //     PageFilters.supplier,
  //     branchesIds,
  //     isBranchesLoaded,
  //     StoresTextMap,
  //     productFormDetails.pageConfig.group_price,
  //     t,
  //   ]
  // );

  const fetchExportProductsInformation = useCallback(
    async (exportRange: ExportRange) => {
      setExportProductInformationModal(false);
      const start = parseInt(exportRange.start);
      const end = parseInt(exportRange.end);
      const limit = RETRIEVE_LIMIT;
      const branchesCount =
        PageFilters.branch.length === 0 ? 1 : PageFilters.branch.length;

      if (!isBranchesLoaded) return;

      const exportDataReqAmount = end - start + 1;
      const totalFetchAmount = Math.min(
        exportDataReqAmount,
        productTotal * branchesCount
      );

      if (totalFetchAmount > EXPORT_LIMIT) {
        setErrorMsg(`Cannot export more than ${EXPORT_LIMIT} rows at once`);
        setIsError(true);
        return;
      }

      setIsLoaderModalOpen(true);

      try {
        const allProducts: any[] = [];

        for (let offset = 0; offset < totalFetchAmount; offset += limit) {
          const sliceStart = start + offset;
          let sliceEnd = sliceStart + limit - 1;

          // Clamp to user-defined end and total fetchable data
          sliceEnd = Math.min(sliceEnd, end, start + totalFetchAmount - 1);

          const rs = await getExportProductsInformation(
            PageFilters.branch.length === 0
              ? `[${transformArrayToStr(branchesIds)}]`
              : `[${transformArrayToStr(PageFilters.branch)}]`,
            PageFilters.productName,
            sliceStart,
            sliceEnd,
            PageFilters.category,
            PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
              ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
              : '',
            PageFilters.barcode,
            PageFilters.supplier
          );

          if (rs?.message === 'OK' && rs.error_code === 0) {
            allProducts.push(...rs.data.products);
          } else {
            console.warn(`Fetch failed for range ${sliceStart}-${sliceEnd}`);
          }
        }
        await exportProductInformationExcel(
          t,
          allProducts,
          StoresTextMap,
          pageConfig.group_price
        );

        setIsLoaderModalOpen(false);
      } catch (error) {
        console.error('Failed to fetch all products:', error);
        setErrorMsg(`Export failed: ${error}`);
        setIsLoaderModalOpen(false);
        setIsError(true);
        setLoaderError(`Export failed: ${error}`);
      }
    },
    [
      PageFilters.productName,
      PageFilters.branch,
      PageFilters.category,
      PageFilters.quantityMin,
      PageFilters.quantityMax,
      PageFilters.barcode,
      PageFilters.supplier,
      branchesIds,
      isBranchesLoaded,
      StoresTextMap,
      pageConfig.group_price,
      t,
      productTotal, // ← don’t forget this in dependencies
    ]
  );

  //* ====== End of Export Products Information ======

  //* ====== Export Products Information Group By Store ======
  // const fetchExportProductsInfoGroupedByStore = useCallback(async () => {
  //   if (productTotal * PageFilters.branch.length > EXPORT_LIMIT) return;
  //   if (!isBranchesLoaded) return;
  //   setIsLoaderModalOpen(true);

  //   try {
  //     const allGroupedProducts: ProductsGroupedByStore[] = [];
  //     const limit = RETRIEVE_LIMIT;
  //     const totalPages = Math.ceil(productTotal / limit);

  //     for (let page = 1; page <= totalPages; page++) {
  //       const rs = await getExportProductsInfoGroupedByStore(
  //         PageFilters.branch.length === 0
  //           ? `[${transformArrayToStr(branchesIds)}]`
  //           : `[${transformArrayToStr(PageFilters.branch)}]`,
  //         PageFilters.productName,
  //         limit,
  //         page,
  //         PageFilters.category,
  //         PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
  //           ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
  //           : '',
  //         PageFilters.barcode,
  //         PageFilters.supplier
  //       );

  //       if (rs?.message === 'OK' && rs.error_code === 0) {
  //         // Merge grouped results by store
  //         rs.data.products.forEach((newStoreGroup: ProductsGroupedByStore) => {
  //           const existing = allGroupedProducts.find(
  //             (g) => g.store_id === newStoreGroup.store_id
  //           );
  //           if (existing) {
  //             existing.products.push(...newStoreGroup.products);
  //           } else {
  //             allGroupedProducts.push({ ...newStoreGroup });
  //           }
  //         });
  //       } else {
  //         console.warn(`Page ${page} failed or returned no data`);
  //       }
  //     }

  //     await exportProductInfoGroupedByStore(
  //       t,
  //       { products: allGroupedProducts, total: productTotal },
  //       StoresTextMap,
  //       productFormDetails.pageConfig.group_price
  //     );

  //     setIsLoaderModalOpen(false);
  //   } catch (error) {
  //     console.error('Failed to fetch all products:', error);
  //     setErrorMsg(`Export failed: ${error}`);
  //     setIsLoaderModalOpen(false);
  //     setIsError(true);
  //     setLoaderError(`Export failed: ${error}`);
  //   }
  // }, [
  //   productTotal,
  //   PageFilters.productName,
  //   PageFilters.branch,
  //   PageFilters.category,
  //   PageFilters.quantityMin,
  //   PageFilters.quantityMax,
  //   PageFilters.barcode,
  //   PageFilters.supplier,
  //   branchesIds,
  //   isBranchesLoaded,
  //   StoresTextMap,
  //   productFormDetails.pageConfig.group_price,
  //   t,
  // ]);

  //* ====== End of Export Products Information Group By Store ======

  // const fetchExportProductsInformation = useCallback(async () => {
  //   if (productTotal * PageFilters.branch.length > EXPORT_LIMIT) return;
  //   if (!isBranchesLoaded) return;
  //   setIsLoadSuccess(false);
  //   try {
  //     const rs = await getExportProductsInformation(
  //       PageFilters.branch && PageFilters.branch.length === 0
  //         ? `[${transformArrayToStr(branchesIds)}]`
  //         : `[${transformArrayToStr(PageFilters.branch)}]`,
  //       PageFilters.productName,
  //       productTotal,
  //       PageDetails.currentPage + 1,
  //       PageFilters.category,
  //       PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
  //         ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
  //         : '',
  //       PageFilters.barcode,
  //       PageFilters.supplier
  //     );

  //     if (rs) {
  //       const { message, error_code, data } = rs;

  //       if (message === 'OK' && error_code === 0) {
  //         const { products } = data;

  //         setProductExportInformation(products);

  //         // setProductTotal(total);
  //         // setProductList(products);

  //         // Log the final mappedRows to verify
  //         // console.log('Mapped Rows:', mappedRows);
  //         // setProductList(mappedRows);
  //       }
  //     }
  //     setIsLoadSuccess(true);
  //   } catch (error) {
  //     console.error('Failed to fetch all products:', error);
  //     if (typeof error === 'string' && error.includes('Validation error: ')) {
  //       const jsonObj = JSON.parse(error.replace('Validation error: ', ''));
  //       console.log(jsonObj);
  //       const txtError = jsonObj[0].msg ? jsonObj[0].msg : 'Validation error';

  //       setErrorMsg(txtError);
  //     } else {
  //       setErrorMsg(`Failed to fetch all products: ${error}`);
  //     }
  //     setIsLoadSuccess(true);
  //     setIsError(true);
  //   }
  // }, [
  //   productTotal,
  //   PageDetails.currentPage,
  //   PageFilters.productName,
  //   PageFilters.branch,
  //   PageFilters.category,
  //   PageFilters.quantityMin,
  //   PageFilters.quantityMax,
  //   PageFilters.barcode,
  //   PageFilters.supplier,
  //   branchesIds,
  //   isBranchesLoaded,
  // ]);

  const fetchAllProducts = useCallback(async () => {
    if (!isBranchesLoaded) return;
    setIsLoadSuccess(false);
    try {
      const mapSimpleProductRows = (products: any[] = []) =>
        products.map((groupedProduct) => ({
          item_id_number: groupedProduct.item_id_number,
          products: [...groupedProduct.products].sort((a: any, b: any) => {
            const aCode = parseInt(a.branch_code || '0', 10);
            const bCode = parseInt(b.branch_code || '0', 10);
            return aCode - bCode;
          }),
        }));
      const hasUnsupportedSimpleFilters =
        (PageFilters.quantityMin !== '' && PageFilters.quantityMax !== '') ||
        PageFilters.tag_ids.length > 0;
      const shouldUseDirectSearch =
        hasUnsupportedSimpleFilters || latestSearchItemIds === null;

      if (shouldUseDirectSearch) {
        const rs = await getSearchProductsLight(
          PageFilters.branch && PageFilters.branch.length === 0
            ? `[${branchesIds.join(',')}]`
            : `[${transformArrayToStr(PageFilters.branch)}]`,
          PageFilters.productName,
          PageDetails.entriesPerPage,
          PageDetails.currentPage + 1,
          PageFilters.category,
          PageFilters.quantityMin !== '' && PageFilters.quantityMax !== ''
            ? `${PageFilters.quantityMin},${PageFilters.quantityMax}`
            : '',
          PageFilters.barcode,
          PageFilters.code,
          PageFilters.supplier,
          PageFilters.tag_ids
        );

        if (rs?.message === 'OK' && rs.error_code === 0) {
          const mappedRows = (data: typeof rs.data.products) =>
            Object.entries(data).map(([item_id_number, productsArr]) => {
              if (
                typeof productsArr === 'object' &&
                productsArr.products &&
                Array.isArray(productsArr.products)
              ) {
                return {
                  item_id_number: parseInt(item_id_number, 10),
                  products: productsArr.products.sort((a: any, b: any) => {
                    const aCode = parseInt(a.branch_code || '0', 10);
                    const bCode = parseInt(b.branch_code || '0', 10);
                    return aCode - bCode;
                  }),
                };
              }

              if (Array.isArray(productsArr)) {
                return {
                  item_id_number: parseInt(item_id_number, 10),
                  products: productsArr.sort((a: any, b: any) => {
                    const aCode = parseInt(a.branch_code || '0', 10);
                    const bCode = parseInt(b.branch_code || '0', 10);
                    return aCode - bCode;
                  }),
                };
              }

              return {
                item_id_number: parseInt(item_id_number, 10),
                products: [],
              };
            });

          setProductTotal(rs.data.total);
          setProductList(mappedRows(rs.data.products));
          dispatch(
            setSearchListCache({
              cacheKey: currentSearchCacheKey,
              latestSearchItemIds,
              productList: mappedRows(rs.data.products),
              productTotal: rs.data.total,
            })
          );
          setIsLoadSuccess(true);
          return;
        }

        setProductTotal(0);
        setProductList([]);
        dispatch(
          setSearchListCache({
            cacheKey: currentSearchCacheKey,
            latestSearchItemIds,
            productList: [],
            productTotal: 0,
          })
        );
        setIsLoadSuccess(true);
        return;
      }

      const currentPage = PageDetails.currentPage + 1;
      if (latestSearchItemIds !== null && latestSearchItemIds.length === 0) {
        setProductTotal(0);
        setProductList([]);
        dispatch(
          setSearchListCache({
            cacheKey: currentSearchCacheKey,
            latestSearchItemIds,
            productList: [],
            productTotal: 0,
          })
        );
        setIsLoadSuccess(true);
        return;
      }

      const selectedStoreIds =
        PageFilters.branch.length === 0
          ? branchesIds.map((branchId) => Number(branchId))
          : PageFilters.branch.map((branchId) => Number(branchId));
      const sanitizedSearchItemIds =
        latestSearchItemIds
          ?.map((itemIdNumber) => Number(itemIdNumber))
          .filter((itemIdNumber) => Number.isFinite(itemIdNumber)) ?? [];

      if (sanitizedSearchItemIds.length === 1) {
        const rs = await postProductsSimple({
          store_ids: selectedStoreIds.filter((storeId) => Number.isFinite(storeId)),
          page: 1,
          limit: PageDetails.entriesPerPage,
          item_id_numbers: sanitizedSearchItemIds,
        });

        if (rs?.message === 'OK' && rs.error_code === 0) {
          const mappedRows = mapSimpleProductRows(rs.data?.products);

          setProductTotal(rs.data?.total ?? mappedRows.length);
          setProductList(mappedRows);
          dispatch(
            setSearchListCache({
              cacheKey: currentSearchCacheKey,
              latestSearchItemIds,
              productList: mappedRows,
              productTotal: rs.data?.total ?? mappedRows.length,
            })
          );
          setIsLoadSuccess(true);
          return;
        }

        setProductTotal(0);
        setProductList([]);
        dispatch(clearSearchListCache());
        setIsLoadSuccess(true);
        return;
      }

      const currentLimit = PageDetails.entriesPerPage;
      const selectedCategoryNumber = PageFilters.category
        ? rawCategories.find(
            (category) => category.id.toString() === PageFilters.category
          )?.category_number
        : undefined;
      const esSearchParams: ProductESSearchParams = {
        ...(PageFilters.productName.trim()
          ? { name: PageFilters.productName.trim() }
          : {}),
        ...(selectedCategoryNumber !== undefined
          ? { category_number: selectedCategoryNumber }
          : {}),
        ...(PageFilters.barcode.trim()
          ? { item_id_number: PageFilters.barcode.trim() }
          : {}),
        ...(PageFilters.code.trim()
          ? { item_code: PageFilters.code.trim() }
          : {}),
        ...(PageFilters.supplier
          ? { supplier_id: Number(PageFilters.supplier) }
          : {}),
      };
      const searchIdsResponse = await getSearchProductPaginationIdsFromES(
        esSearchParams,
        currentPage,
        currentLimit
      );

      if (
        !searchIdsResponse ||
        searchIdsResponse.message !== 'OK' ||
        searchIdsResponse.error_code !== 0
      ) {
        setProductTotal(0);
        setProductList([]);
        dispatch(clearSearchListCache());
        setIsLoadSuccess(true);
        return;
      }

      const itemIdNumbers = (searchIdsResponse.data?.limit_results?.list ?? [])
        .map((itemIdNumber) => Number(itemIdNumber))
        .filter((itemIdNumber) => Number.isFinite(itemIdNumber));

      if (itemIdNumbers.length === 0) {
        setProductTotal(0);
        setProductList([]);
        dispatch(
          setSearchListCache({
            cacheKey: currentSearchCacheKey,
            latestSearchItemIds,
            productList: [],
            productTotal: 0,
          })
        );
        setIsLoadSuccess(true);
        return;
      }

      const rs = await postProductsSimple({
        store_ids: selectedStoreIds.filter((storeId) => Number.isFinite(storeId)),
        page: 1,
        limit: PageDetails.entriesPerPage,
        item_id_numbers: itemIdNumbers,
      });

      if (rs) {
        const { message, error_code, data } = rs;

        if (message === 'OK' && error_code === 0) {
          const mappedRows = mapSimpleProductRows(data.products);

          // total_amount = ยอดรวมทั้งหมดจาก server (limit_results.amount เป็นจำนวนเฉพาะในหน้านี้)
          // ทำให้ totalPages = ceil(total / limit) ตรงกับ total_page ของ server
          const searchTotalCount =
            searchIdsResponse.data?.total_amount ??
            latestSearchItemIds?.length ??
            itemIdNumbers.length;

          setProductTotal(searchTotalCount);
          setProductList(mappedRows);
          dispatch(
            setSearchListCache({
              cacheKey: currentSearchCacheKey,
              latestSearchItemIds,
              productList: mappedRows,
              productTotal: searchTotalCount,
            })
          );

          // const mappedRows = Object.entries(products).map(
          //   ([item_id_number, productsArr]) => ({
          //     item_id_number,
          //     products: productsArr,
          //   })
          // );
          // console.log('mappedRows');
          // console.log(mappedRows);

          // const mappedRows = Object.entries(products).map(
          //   ([item_id_number, productsArr]) => ({
          //     item_id_number,
          //     // Explicitly assert productsArr as GetProductByIdFromAPI[]
          //     products: (productsArr as any).map((product: any) => ({
          //       ...product, // Spread the product's properties
          //     })),
          //   })
          // );

          // const mappedRows = Object.entries(products).map(
          //   ([item_id_number, productsArr]) => {
          //     const sortedProducts = (productsArr as any).sort(
          //       (a: any, b: any) => {
          //         const aCode = parseInt(a.branch_code || '0', 10);
          //         const bCode = parseInt(b.branch_code || '0', 10);
          //         return aCode - bCode;
          //       }
          //     );

          //     return {
          //       item_id_number,
          //       products: sortedProducts,
          //     };
          //   }
          // );

          // console.log('mappedRows');
          // console.log(mappedRows);

          // setRowProducts(mappedRows);

          if (
            PageFilters.supplier !== '' ||
            PageFilters.quantityMin ||
            PageFilters.barcode !== '' ||
            PageFilters.quantityMax !== ''
          ) {
            setIsAdvanceSearch(true);
          }
          setIsLoadSuccess(true);
        } else {
          setProductTotal(0);
          setProductList([]);
          dispatch(clearSearchListCache());
          setIsLoadSuccess(true);
        }
      }
    } catch (error) {
      console.error('Failed to fetch all products:', error);
      if (typeof error === 'string' && error.includes('Validation error: ')) {
        const jsonObj = JSON.parse(error.replace('Validation error: ', ''));
        const txtError = jsonObj[0].msg ? jsonObj[0].msg : 'Validation error';

        setErrorMsg(txtError);
      } else {
        setErrorMsg(`Failed to fetch all products: ${error}`);
      }
      setIsLoadSuccess(true);
      setIsError(true);
      setProductTotal(0);
      setProductList([]);
      dispatch(clearSearchListCache());
    }
  }, [
    currentSearchCacheKey,
    dispatch,
    PageDetails.entriesPerPage,
    PageDetails.currentPage,
    PageFilters.branch,
    PageFilters.productName,
    PageFilters.category,
    PageFilters.quantityMin,
    PageFilters.quantityMax,
    PageFilters.barcode,
    PageFilters.code,
    PageFilters.supplier,
    PageFilters.tag_ids,
    branchesIds,
    isBranchesLoaded,
    latestSearchItemIds,
    rawCategories,
  ]);

  useEffect(() => {
    if (isBranchesLoaded && branches.length > 0) {
      if (!hasUsedInitialCacheRef.current && shouldHydrateFromCache) {
        hasUsedInitialCacheRef.current = true;
        setIsLoadSuccess(false);
        const timer = window.setTimeout(() => {
          setIsLoadSuccess(true);
        }, cacheHydrationDelayMs);

        return () => {
          window.clearTimeout(timer);
        };
      }

      if (!hasUsedInitialCacheRef.current) {
        hasUsedInitialCacheRef.current = true;
      }

      if (!shouldHydrateFromCache) {
        fetchAllProducts();
        return;
      }
    }
  }, [
    branches.length,
    cacheHydrationDelayMs,
    fetchAllProducts,
    isBranchesLoaded,
    shouldHydrateFromCache,
  ]);
  // const hasFetchedRef = useRef(false);

  // useEffect(() => {
  //   if (!hasFetchedRef.current && isBranchesLoaded && branches.length > 0) {
  //     fetchAllProducts();
  //     hasFetchedRef.current = true;
  //   } else if (hasFetchedRef) {
  //     setIsLoadSuccess(true);
  //   }
  // }, [fetchAllProducts, branches.length, isBranchesLoaded]);

  useEffect(() => {
    if (productList) {
      setIsLoadSuccess(true);
    } else {
      setIsLoadSuccess(false);
    }
  }, [productList]);

  const fetchPricesById = useCallback(async (id: number, store_id: number) => {
    try {
      const rs = await getProductPricesById(id, store_id);
      if (rs.message === 'OK' && rs.error_code === 0) {
        return rs.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Failed to fetch Prices By Id:', error);
      return null;
    }
  }, []);
  const fetchCheckComposite = useCallback(async (item_id_number: number) => {
    try {
      const rs = await getCheckComposite(item_id_number);
      if (rs.message === 'OK' && rs.error_code === 0) {
        return rs.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Failed to fetch Prices By Id:', error);
      return null;
    }
  }, []);

  //todo ============== Delete functionallity ================ //

  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);

  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState<
    number[]
  >([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] =
    useState<boolean>(false);
  const [isCheckAll, setIsCheckAll] = useState<boolean>(false);

  const deleteMultiple = async () => {
    const checkall = document.getElementById('checkBoxAll') as HTMLInputElement;

    if (selectedCheckBoxDelete && selectedCheckBoxDelete.length > 0) {
      const response: any = await deleteBulkProductsByItemIdNumber(
        selectedCheckBoxDelete
      );
      const { message, error_code, data } = response;
      if (message === 'OK' && error_code === 0) {
        toast.success(data.message, { autoClose: 3000 });
        fetchAllProducts();
      } else {
        toast.error(message, { autoClose: 3000 });
      }
    }
    setSelectedCheckBoxDelete([]);
    setIsCheckAll(false);
    setIsMultiDeleteButton(false);
    if (checkall) {
      checkall.checked = false;
    }
  };

  //todo ============== Delete functionallity ================ //

  const checkedAll = useCallback(() => {
    const updatedCheckAllState = !isCheckAll;
    setIsCheckAll(updatedCheckAllState);
    const ele = document.querySelectorAll<HTMLInputElement>('.productCheckBox');

    const tmp: number[] = [];
    if (updatedCheckAllState) {
      ele.forEach((ele) => {
        ele.checked = true;
        tmp.push(parseInt(ele.value, 10));
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    const CheckedEle = document.querySelectorAll('.productCheckBox:checked');
    if (CheckedEle.length > 0) {
      setIsMultiDeleteButton(true);
    } else {
      setIsMultiDeleteButton(false);
    }

    setSelectedCheckBoxDelete(tmp);
  }, [isCheckAll]);

  const handleCheckboxChange = (id: number) => {
    const ele = document.querySelectorAll('.productCheckBox:checked');
    if (ele.length > 0) {
      setIsMultiDeleteButton(true);
    } else {
      setIsMultiDeleteButton(false);
    }

    setSelectedCheckBoxDelete((prevSelected: number[]) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((selectedId: number) => selectedId !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const ProductColumns: ColumnDef<GetAllProductsRow, any>[] = useMemo(
    () =>
      [
        // # Column
        columnHelper.display({
          id: '#',
          meta: {
            // style: { width: width > 768 ? ProductTableColumnWidth.id : '' },
          },
          header: () => (
            <div className="text-left">
              {/* <div className="text-center"> */}
              <input
                type="checkbox"
                id="checkBoxAll"
                data-testid="checkbox-all"
                className="form-check-input"
                onClick={() => checkedAll()}
                checked={isCheckAll}
              />
            </div>
          ),
          cell: (cell) => {
            const itemIdNumber = cell.row.original.products[0].item_id_number;
            return (
              <input
                type="checkbox"
                className="productCheckBox form-check-input"
                value={itemIdNumber}
                data-testid={`checkbox-product-${itemIdNumber}`}
                checked={selectedCheckBoxDelete.includes(itemIdNumber)}
                onChange={() => handleCheckboxChange(itemIdNumber)}
              />
            );
          },
          enableColumnFilter: false,
          enableSorting: false,
        }),

        // Images column
        columnHelper.display({
          id: 'images',
          header: () => (
            <div className="text-left">{t('ProductPage_Items')}</div>
          ),
          // meta: {
          //   // style: { width: width > 768 ? ProductTableColumnWidth.images : '' },

          // },
          meta: {
            cellStyle: {
              alignContent: 'flex-start',
              maxWidth: getProductColumnWidth(isMobile, 'images', 'maxWidth'),
              minWidth: getProductColumnWidth(isMobile, 'images', 'minWidth'),
              // maxWidth: ProductColumnWidthStyle.images.maxWidth,
              // minWidth: ProductColumnWidthStyle.images.minWidth,
              // whiteSpace: 'pre-wrap',
              // wordBreak: 'break-word',
            },
          },
          cell: (cell) => {
            const firstProduct = cell.row.original.products[0];

            const { thumbs, large } = firstProduct?.images ?? {};
            const name = firstProduct?.name ?? '';
            const category = truncateText_v2(firstProduct?.category_name) ?? '';

            return (
              <div className="d-flex align-content-flex-start">
                <div
                  className={`${styles['zoom']} py-0 px-0 my-0 mx-0 d-flex align-content-flex-start`}
                  style={{
                    width: DISPLAY_IMAGE_SIZE,
                    height: DISPLAY_IMAGE_SIZE,
                    overflow: 'hidden',
                    display: 'inline-block',
                    // marginRight: '10px',
                    transition: 'transform 0.3s ease',
                  }}
                >
                  {thumbs ? (
                    <a
                      href={large}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none' }}
                    >
                      <ImageWithFallback
                        className="d-flex align-content-flex-start px-0 mx-0"
                        src={thumbs}
                        alt={name}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '0.25rem',
                        }}
                        errImgSize={DISPLAY_IMAGE_SIZE.toString()}
                      />
                    </a>
                  ) : (
                    <FaImage
                      className="d-flex align-content-flex-start px-0 mx-0"
                      style={{ fontSize: DISPLAY_IMAGE_SIZE }}
                      color="gray"
                    />
                  )}
                </div>
                <div
                  className="d-flex flex-column align-content-flex-start"
                  style={{ marginLeft: '1.5rem', width: '50%' }}
                >
                  <div
                    style={{
                      alignContent: 'flex-start',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                    }}
                  >
                    {name}
                  </div>
                  <div
                    className="text-muted"
                    style={{
                      alignContent: 'flex-start',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                    }}
                  >
                    {t('Category') + ' : ' + category}
                  </div>
                </div>
              </div>
            );
          },
          enableColumnFilter: false,
        }),
        ...[{ id: 'code', label: 'ProductPage_Code' }].map(({ id, label }) =>
          columnHelper.accessor(
            (row) => row.products[0]?.[id as keyof GetProductLightByIdFromAPI],
            {
              id,
              header: () => <div className="text-left">{t(label)}</div>,
              // header: ({ column }) => createSortableHeader(t(label), column),
              cell: (cell) => (
                <div className="d-flex align-content-flex-start px-0 mx-0">
                  <div>{String(cell.getValue() ?? '-')}</div>
                </div>
              ),
              meta: {
                cellStyle: {
                  alignContent: 'flex-start',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  minWidth: getProductColumnWidth(isMobile, 'code', 'minWidth'),
                  maxWidth: getProductColumnWidth(isMobile, 'code', 'maxWidth'),

                  // minWidth: ProductColumnWidthStyle.code.minWidth,
                  // maxWidth: ProductColumnWidthStyle.code.maxWidth,
                },
              },
              enableColumnFilter: false,
              enableSorting: false,
              // sortingFn: 'text',
            }
          )
        ),
        columnHelper.display({
          id: 'tags',
          header: () => <div className="text-left">{t('Tags')}</div>,
          meta: {
            cellStyle: {
              alignContent: 'flex-start',
              // minWidth: ProductColumnWidthStyle.tags.minWidth,
              // maxWidth: ProductColumnWidthStyle.tags.maxWidth,
              minWidth: getProductColumnWidth(isMobile, 'tags', 'minWidth'),
              maxWidth: getProductColumnWidth(isMobile, 'tags', 'maxWidth'),
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            },
          },
          cell: (cell) => {
            const tags = cell.row.original.products[0]?.tags || [];
            return tags.length > 0 ? (
              <div
                className="d-flex flex-wrap align-items-start"
                style={{ gap: '4px' }}
              >
                {tags.map((tag, index) => (
                  <span
                    key={index}
                    className="badge tag-soft-badge"
                    style={
                      {
                        fontSize: '0.75rem',
                        whiteSpace: 'normal',
                        '--color': `${tag.color}`,
                      } as React.CSSProperties
                    }
                  >
                    {truncateText_v2(tag.name)}
                  </span>
                  // <span
                  //   key={index}
                  //   className="badge bg-success"
                  //   style={{ fontSize: '0.75rem', whiteSpace: 'normal' }}
                  // >
                  //   {tag.name}
                  // </span>
                ))}
              </div>
            ) : null;
          },

          // cell: (cell) => {
          //   const tags = cell.row.original.products[0]?.tags || [];
          //   return tags.length > 0 ? (
          //     <div className="d-flex justify-content-start flex-wrap gap-1">
          //       {tags.map((tag, index) => (
          //         <span
          //           key={index}
          //           className="badge bg-success me-1"
          //           style={{ fontSize: '0.75rem' }}
          //         >
          //           {tag.name}
          //         </span>
          //       ))}
          //     </div>
          //   ) : null;
          // },
        }),
        ...[{ id: 'barcode', label: 'ProductField_BarcodeID' }].map(
          ({ id, label }) =>
            columnHelper.accessor(
              (row) =>
                row.products[0]?.[id as keyof GetProductLightByIdFromAPI],
              {
                id,
                header: () => <div className="text-left">{t(label)}</div>,
                // header: ({ column }) => createSortableHeader(t(label), column),
                cell: (cell) => (
                  <div className="d-flex align-content-flex-start px-0 mx-0">
                    <div>{String(cell.getValue() ?? '-')}</div>
                  </div>
                ),
                meta: {
                  cellStyle: {
                    alignContent: 'flex-start',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    // minWidth: ProductColumnWidthStyle.barcode.minWidth,
                    // maxWidth: ProductColumnWidthStyle.barcode.maxWidth,
                    minWidth: getProductColumnWidth(
                      isMobile,
                      'barcode',
                      'minWidth'
                    ),
                    maxWidth: getProductColumnWidth(
                      isMobile,
                      'barcode',
                      'maxWidth'
                    ),
                  },
                },
                enableColumnFilter: false,
                enableSorting: false,
                // sortingFn: 'text',
              }
            )
        ),
        // columnHelper.accessor(
        //   (row) =>
        //     row.products.map((product: GetProductByIdFromAPI, i: number) => (
        //       <div key={`storeId-${i}`}>
        //         {branchCodes.find((b) => b.storeId === product.store_id)
        //           ?.code ?? '-'}
        //       </div>
        //     )),
        //   {
        //     id: 'store_id',
        //     meta: {
        //       // style: { width: ProductTableColumnWidth.store_id }
        //     },
        //     header: ({ column }) => createSortableHeader(t('Branch'), column),
        //     cell: (cell) => cell.getValue() ?? '-',
        //     enableColumnFilter: false,
        //     sortingFn: 'alphanumeric',
        //   }
        // ),
        columnHelper.display({
          id: 'store_id',
          // meta: {
          //   // style: { width: ProductTableColumnWidth.store_id }
          // },
          meta: {
            cellStyle: {
              alignContent: 'flex-start',
            },
          },
          header: () => <div className="text-left">{t('Branch')}</div>,
          // cell: (cell) => cell.getValue() ?? '-',
          cell: ({ row }) =>
            row.original.products.map(
              (product: GetProductLightByIdFromAPI, i: number) => (
                <div
                  key={`storeId-${i}`}
                  className="mb-2"
                  style={MinHeightStyle}
                >
                  {branchCodes.find((b) => b.storeId === product.store_id)
                    ?.code ?? '-'}
                </div>
              )
            ) ?? '-',
        }),

        ...[
          { id: 'cost_price', label: 'ProductField_CostPrice' },
          { id: 'unit_price', label: 'ProductField_UnitPrice' },
          { id: 'quantity', label: 'ProductPage_QuantityBalance' },
        ].map(({ id, label }) =>
          columnHelper.display({
            id,
            meta: {
              cellStyle: {
                alignContent: 'flex-start',
              },
            },
            header: () => <div className="text-center">{t(label)}</div>,
            cell: ({ row }) => (
              <>
                {row.original.products.map(
                  (product: GetProductLightByIdFromAPI, i: number) => (
                    <div
                      key={`${product.id}-${i}`}
                      id={`${id}-${product.id}`}
                      className={`${id}-${product.id} mb-2 ${
                        TextColumnsStyle[id as keyof typeof TextColumnsStyle]
                      }`}
                      style={MinHeightStyle}
                    >
                      {/* {String(
                        product[id as keyof GetProductByIdFromAPI] ?? '-'
                      )} */}
                      {formatNumberWithCommas(
                        String(product[id as keyof GetProductLightByIdFromAPI]),
                        id === 'quantity' ? 3 : 2
                      )}
                    </div>
                  )
                )}
              </>
            ),
          })
        ),

        // Action
        columnHelper.display({
          id: 'action',
          // meta: {
          //   // style: { width: ProductTableColumnWidth.action }
          // },
          meta: {
            cellStyle: {
              alignContent: 'flex-start',
            },
          },
          header: () => (
            // <div className="d-flex justify-content-center">
            <div className="d-flex justify-content-flex-start">
              <span>Action</span>
              <ColumnSelectionModal
                AllColumn={AllColumn}
                visibleColumns={visibleColumns}
                isColumnModalOpen={isColumnModalOpen}
                exceptedColumn={['#', 'action']}
                toggleColumnModal={toggleColumnModal}
                handleColumnVisibilityChange={handleColumnVisibilityChange}
              />
            </div>
          ),
          cell: ({ row }) => {
            return (
              <>
                {row.original.products.map(
                  (product: GetProductLightByIdFromAPI, i: number) => {
                    const productId = product?.id;
                    const toggleId = `dd-menu-${productId}`;

                    const handleMouseEnter = () => {
                      const toggleButton = document.querySelector(
                        `[data-toggle="${toggleId}"]`
                      );
                      if (toggleButton) (toggleButton as HTMLElement).click();
                    };

                    const handleMouseLeave = () => {
                      const dropdownMenu = document.querySelector(
                        `[data-dropdown-menu="${toggleId}"]`
                      );
                      if (dropdownMenu) {
                        const toggleButton = document.querySelector(
                          `[data-toggle="${toggleId}"]`
                        );
                        if (
                          toggleButton &&
                          dropdownMenu.classList.contains('show')
                        ) {
                          (toggleButton as HTMLElement).click();
                        }
                      }
                    };

                    return (
                      <ul
                        key={`${productId}-${i}`}
                        className="list-inline hstack gap-0 mb-2"
                        onMouseLeave={handleMouseLeave}
                      >
                        <li className="list-inline-item">
                          {i === 0 ? (
                            // <div
                            //   onClick={() =>
                            //     history(`${productURI}/${productId}`)
                            //   }
                            //   role="button"
                            //   style={{
                            //     display: 'flex',
                            //     cursor: 'pointer',
                            //     padding: '0',
                            //     width: ProductListActionButtons.width,
                            //     height: ProductListActionButtons.height,
                            //   }}
                            //   className={`align-items-flex-start btn btn-outline-success p-1 `}
                            //   title={t('Edit')}
                            // >
                            //   {/* <MdEdit fontSize={'1rem'} /> */}
                            //   <FaRegPenToSquare
                            //     // style={{ marginLeft: '0.25rem' }}

                            //     // fontSize={'1rem'}
                            //     fontSize={'20px'}
                            //   />
                            // </div>

                            <IconActionButton
                              onClick={() =>
                                history(`${productURI}/${productId}`)
                              }
                              icon={
                                <FaRegPenToSquare
                                  fontSize={ProductListActionButtons.icon}
                                />
                              }
                              title={t('Edit')}
                              height={ProductListActionButtons.button.height}
                              width={ProductListActionButtons.button.width}
                            />
                          ) : (
                            <div
                              style={{
                                width: ProductListActionButtons.button.width,
                                height: ProductListActionButtons.button.height,
                              }}
                            ></div>
                            // <div
                            //   style={{ width: '1.625rem', height: '1.625rem' }}
                            // ></div>
                          )}
                        </li>

                        <li className="list-inline-item">
                          {/* <div
                            title={t('Edit Product Prices')}
                            onClick={async () => {
                              const { id, store_id, item_id_number } = product;
                              // const branchPrices =
                              //   product?.prices_by_branch.find(
                              //     (p) => p.store_id === product.store_id
                              //   );

                              // const priceData: any =
                              //   branchPrices?.prices[0] || {};
                              //                               const initialValues = {
                              //   store_id: branchPrices?.store_id,
                              //   item_id: branchPrices?.item_id,
                              //   item_id_number: branchPrices?.item_id_number,
                              //   cost_price: String(priceData.cost_price ?? ''),
                              //   unit_price: String(priceData.unit_price ?? ''),
                              //   unit_price1: String(
                              //     priceData.unit_price1 ?? ''
                              //   ),
                              //   unit_price2: String(
                              //     priceData.unit_price2 ?? ''
                              //   ),
                              //   unit_price3: String(
                              //     priceData.unit_price3 ?? ''
                              //   ),
                              //   unit_price4: String(
                              //     priceData.unit_price4 ?? ''
                              //   ),
                              // };
                              let initialValues = {
                                store_id: store_id,
                                item_id: id,
                                item_id_number: item_id_number,
                                cost_price: '',
                                unit_price: '',
                                unit_price1: '',
                                unit_price2: '',
                                unit_price3: '',
                                unit_price4: '',
                              };
                              if (store_id && id) {
                                const getPrices = await fetchPricesById(
                                  id,
                                  store_id
                                );
                                if (getPrices) {
                                  initialValues = {
                                    store_id: store_id,
                                    item_id: id,
                                    item_id_number: item_id_number,
                                    cost_price: String(getPrices.cost_price),
                                    unit_price: String(getPrices.unit_price),
                                    unit_price1: String(getPrices.unit_price1),
                                    unit_price2: String(getPrices.unit_price2),
                                    unit_price3: String(getPrices.unit_price3),
                                    unit_price4: String(getPrices.unit_price4),
                                  };
                                }
                              }

                              dispatch(setPriceModalOpen(true));
                              dispatch(setActivePriceIndex(productId));
                              dispatch(setPriceValues(initialValues));
                              dispatch(
                                setPriceEditKey(row.original.item_id_number)
                              );
                            }}
                            role="button"
                            style={{
                              display: 'flex',
                              cursor: 'pointer',
                              padding: '0',
                            }}
                            className="align-items-flex-start btn btn-outline-success"
                          >

                            <MdCurrencyExchange
                              style={{
                                margin: '0.25rem',
                              }}
                              fontSize={'1rem'}
                            />
                          </div> */}
                          <IconActionButton
                            title={t('Edit Product Prices')}
                            onClick={async () => {
                              const { id, store_id, item_id_number } = product;

                              let initialValues = {
                                store_id: store_id,
                                item_id: id,
                                item_id_number: item_id_number,
                                cost_price: '',
                                unit_price: '',
                                unit_price1: '',
                                unit_price2: '',
                                unit_price3: '',
                                unit_price4: '',
                              };
                              if (store_id && id) {
                                const getPrices = await fetchPricesById(
                                  id,
                                  store_id
                                );
                                if (getPrices) {
                                  initialValues = {
                                    store_id: store_id,
                                    item_id: id,
                                    item_id_number: item_id_number,
                                    cost_price: String(getPrices.cost_price),
                                    unit_price: String(getPrices.unit_price),
                                    unit_price1: String(getPrices.unit_price1),
                                    unit_price2: String(getPrices.unit_price2),
                                    unit_price3: String(getPrices.unit_price3),
                                    unit_price4: String(getPrices.unit_price4),
                                  };
                                }
                              }

                              dispatch(setPriceModalOpen(true));
                              dispatch(setActivePriceIndex(productId));
                              dispatch(setPriceValues(initialValues));
                              dispatch(
                                setPriceEditKey(row.original.item_id_number)
                              );
                            }}
                            icon={
                              <MdCurrencyExchange
                                fontSize={ProductListActionButtons.icon}
                              />
                            }
                            height={ProductListActionButtons.button.height}
                            width={ProductListActionButtons.button.width}
                          />
                        </li>

                        {/* <li className="list-inline-item">
                          <div
                            title={t('Update Inventory')}
                            onClick={() => {
                              if (product.product_stock_type === 1) {
                                setIsError(true);
                                setErrorMsg(
                                  t(
                                    "Stock Type is Item without stock  , it's not edit stock"
                                  )
                                );
                                return;
                              }

                              if (product.inventory_type === 2) {
                                setIsError(true);
                                setErrorMsg(
                                  t(
                                    "Stock Type is Composite Items , it's not edit stock"
                                  )
                                );
                                return;
                              } else if (product.inventory_type === 3) {
                                setIsError(true);
                                setErrorMsg(
                                  t(
                                    "Stock Type is Serial/IMEI , it's not edit stock"
                                  )
                                );
                                return;
                              }

                              if (product.inventory_type !== 1) return;
                              const initialValues = {
                                barcode: product.barcode,
                                name: product.name,
                                categoryName: product.category_name,
                                currentQuantity: product.quantity,
                                newQuantity: '',
                                transComment: '',
                              };

                              dispatch(setInventoryModalOpen(true));
                              dispatch(setActiveInventoryIndex(productId));
                              dispatch(setInventoryValues(initialValues));
                              dispatch(
                                setInventoryEditKey(row.original.item_id_number)
                              );
                            }}
                            role="button"
                            style={{
                              display: 'flex',
                              cursor: 'pointer',
                              padding: '0',
                            }}
                            className="align-items-flex-start btn btn-outline-success"
                          >
                            <FaListAlt
                              size={24}
                              style={{ padding: '0.2rem' }}
                            />
                          </div>
                        </li> */}

                        {/* <li className="list-inline-item">
                          <div
                            title={t('Barcodes Item')}
                            onClick={() => {
                              window.open(
                                `https://pos2uapp.com/it/lib/barcode/gen3.php?t=see_dlabel&s=a7&c=${product.barcode}&n=${product.name}&p=${product.unit_price} บาท`,
                                '_blank'
                              );
                            }}
                            role="button"
                            style={{
                              display: 'flex',
                              cursor: 'pointer',
                              padding: '0',
                            }}
                            className="align-items-flex-start btn btn-outline-success"
                          >
                            <FaBarcode
                              size={24}
                              style={{ padding: '0.2rem' }}
                            />
                          </div>
                        </li> */}

                        {/* <li className="list-inline-item">
                          <div
                            title={t('Inventory Count Details')}
                            onClick={() => {
                              const initialValues = {
                                itemIdNumber: product.code,
                                barcode: product.barcode,
                                name: product.name,
                                quantityBalance: product.quantity,
                              };

                              dispatch(setInventoryDetailsModalOpen(true));
                              dispatch(
                                setActiveInventoryDetailsIndex(productId)
                              );
                              dispatch(
                                setInventoryDetailsValues(initialValues)
                              );
                              dispatch(
                                setInventoryDetailsEditKey(
                                  row.original.item_id_number
                                )
                              );
                            }}
                            role="button"
                            style={{
                              display: 'flex',
                              cursor: 'pointer',
                              padding: '0',
                            }}
                            className="align-items-flex-start btn btn-outline-success"
                          >
                            <FaListUl size={24} style={{ padding: '0.2rem' }} />
                          </div>
                        </li> */}
                        <li className="list-inline-item">
                          <ButtonGroup>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="span"
                                data-toggle={toggleId}
                                onMouseEnter={handleMouseEnter}
                                style={{
                                  cursor: 'pointer',
                                  width: ProductListActionButtons.button.width,
                                  height:
                                    ProductListActionButtons.button.height,
                                }}
                                className="btn btn-outline-success px-0 py-0 d-flex align-items-center justify-content-center"
                              >
                                <i
                                  className="las las la-ellipsis-h"
                                  style={{
                                    fontSize: ProductListActionButtons.icon,
                                  }}
                                ></i>
                              </DropdownToggle>
                              <DropdownMenu
                                className="dropdownmenu-success"
                                data-dropdown-menu={toggleId}
                              >
                                {/* <DropdownItem
                                  id={`edit-btn-${productId}`}
                                  onClick={() =>
                                    history(`${productURI}/${productId}`)
                                  }
                                >
                                  {t('Edit')}
                                </DropdownItem> */}

                                <DropdownItem
                                  id={`update-inventory-btn-${productId}`}
                                  className="text-steel-gray"
                                  onMouseOver={(e) =>
                                    e.currentTarget.classList.remove(
                                      'text-steel-gray'
                                    )
                                  }
                                  onMouseOut={(e) =>
                                    e.currentTarget.classList.add(
                                      'text-steel-gray'
                                    )
                                  }
                                  onClick={async () => {
                                    if (product.product_stock_type === 1) {
                                      setIsError(true);
                                      setErrorMsg(
                                        t(
                                          "Stock Type is Item without stock  , it's not edit stock"
                                        )
                                      );
                                      return;
                                    }

                                    if (product.inventory_type === 2) {
                                      setIsError(true);
                                      setErrorMsg(
                                        t(
                                          "Stock Type is Composite Items , it's not edit stock"
                                        )
                                      );
                                      return;
                                    } else if (product.inventory_type === 3) {
                                      setIsError(true);
                                      setErrorMsg(
                                        t(
                                          "Stock Type is Serial/IMEI , it's not edit stock"
                                        )
                                      );
                                      return;
                                    }

                                    if (product.inventory_type !== 1) return;
                                    const checkComposite =
                                      await fetchCheckComposite(
                                        product.item_id_number
                                      );
                                    if (checkComposite?.is_composite) {
                                      setIsError(true);
                                      setErrorMsg(
                                        t(
                                          "Stock Type is Composite Items , it's not edit stock"
                                        )
                                      );
                                      return;
                                    }

                                    const initialValues = {
                                      barcode: product.barcode,
                                      name: product.name,
                                      categoryName: product.category_name,
                                      currentQuantity: product.quantity,
                                      newQuantity: '',
                                      transComment: '',
                                    };

                                    dispatch(setInventoryModalOpen(true));
                                    dispatch(
                                      setActiveInventoryIndex(productId)
                                    );
                                    dispatch(setInventoryValues(initialValues));
                                    dispatch(
                                      setInventoryEditKey(
                                        row.original.item_id_number
                                      )
                                    );
                                  }}
                                >
                                  <div title={t('Update Inventory')}>
                                    <FaListAlt
                                      size={24}
                                      style={{ padding: '0.2rem' }}
                                    />{' '}
                                    {t('Update Inventory')}
                                  </div>
                                </DropdownItem>

                                <DropdownItem
                                  id={`barcodes-item-${productId}`}
                                  className="text-steel-gray"
                                  onMouseOver={(e) =>
                                    e.currentTarget.classList.remove(
                                      'text-steel-gray'
                                    )
                                  }
                                  onMouseOut={(e) =>
                                    e.currentTarget.classList.add(
                                      'text-steel-gray'
                                    )
                                  }
                                  onClick={() => {
                                    window.open(
                                      `https://pos2uapp.com/it/lib/barcode/gen3.php?t=see_dlabel&s=a7&c=${product.barcode}&n=${product.name}&p=${product.unit_price} บาท`,
                                      '_blank'
                                    );
                                  }}
                                >
                                  <div title={t('Barcodes Item')}>
                                    <FaBarcode
                                      size={24}
                                      style={{ padding: '0.2rem' }}
                                    />{' '}
                                    {t('Barcodes Item')}
                                  </div>
                                </DropdownItem>

                                <DropdownItem
                                  id={`inventory-count-detail-${productId}`}
                                  className="text-steel-gray"
                                  onMouseOver={(e) =>
                                    e.currentTarget.classList.remove(
                                      'text-steel-gray'
                                    )
                                  }
                                  onMouseOut={(e) =>
                                    e.currentTarget.classList.add(
                                      'text-steel-gray'
                                    )
                                  }
                                  onClick={() => {
                                    const initialValues = {
                                      itemIdNumber: product.code,
                                      barcode: product.barcode,
                                      name: product.name,
                                      quantityBalance: product.quantity,
                                    };

                                    dispatch(
                                      setInventoryDetailsModalOpen(true)
                                    );
                                    dispatch(
                                      setActiveInventoryDetailsIndex(productId)
                                    );
                                    dispatch(
                                      setInventoryDetailsValues(initialValues)
                                    );
                                    dispatch(
                                      setInventoryDetailsEditKey(
                                        row.original.item_id_number
                                      )
                                    );
                                  }}
                                >
                                  <div title={t('Inventory Count Details')}>
                                    <FaListUl
                                      size={24}
                                      style={{ padding: '0.2rem' }}
                                    />{' '}
                                    {t('Inventory Count Details')}
                                  </div>
                                </DropdownItem>
                                {/* <DropdownItem
                                  id={`edit-price-btn-${productId}`}
                                  onClick={() => {
                                    // dispatch(setPriceModalOpen(true));
                                    // You could pre-fill values if needed here.
                                  }}
                                  disabled={true}
                                >
                                  {t('Edit Price')}
                                </DropdownItem> */}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </ButtonGroup>
                        </li>
                      </ul>
                    );
                  }
                )}
              </>
            );
          },

          enableColumnFilter: false,
          enableSorting: false,
        }),
      ].filter((column) => column.id && visibleColumns.includes(column.id)),
    [
      t,
      history,
      columnHelper,
      AllColumn,
      isColumnModalOpen,
      visibleColumns,
      checkedAll,
      selectedCheckBoxDelete,
      isCheckAll,
      branchCodes,
      dispatch,
      productURI,
      isMobile,
      fetchPricesById,
      fetchCheckComposite,
      MinHeightStyle,
    ]
  );

  const totalPages = Math.ceil(productTotal / PageDetails.entriesPerPage);

  const handlePageChange = (newPage: number) => {
    dispatch(setCurrentPage(newPage));
  };
  const handleProductSearchSubmit = (
    searchFilters: ProductSearchFilters,
    itemIdNumbers: string[] | null = null
  ) => {
    setIsCheckAll(false);
    setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete([]);
    setLatestSearchItemIds(itemIdNumbers);
    dispatch(
      setPageFilters((prev: ProductSearchFilters) => ({
        ...prev,
        ...searchFilters,
      }))
    );
    dispatch(setCurrentPage(0));
  };

  document.title = t('Items') + ' | POS2U';

  return (
    <div className="page-content">
      <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={productList}
      />
      <ModalBackdropError
        isError={isError}
        setIsError={setIsError}
        message={errorMsg}
        ButtonMsg="OK"
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
        recordId=""
        title={t('Delete Product')}
        message={
          selectedCheckBoxDelete.length === 1
            ? t('SingleDeleteAlertMessage')
            : t('MultiDeleteAlertMessage', {
                items: selectedCheckBoxDelete.length,
              })
        }
        annotation={
          selectedCheckBoxDelete.length === 1
            ? t('SingleDeleteProductAnnotation')
            : t('MultiDeleteProductAnnotation')
        }
        cancelBtnMsg={t('Cancel')}
        confirmBtnMsg={t('Delete')}
      />
      {/* <ConfirmModal
        show={exportProductInformationModal}
        onConfirmClick={async () => {
          // deleteMultiple();
          // await exportProductInformationExcel(
          //   t,
          //   productExportInformation,
          //   StoresTextMap,
          //   productFormDetails.pageConfig.group_price
          // );
          // await fetchExportProductsInformation();
          await fetchExportProductsInfoGroupedByStore();
          setExportProductInformationModal(false);
        }}
        onCloseClick={() => setExportProductInformationModal(false)}
      /> */}
      <ProductExportModal
        title={t('Item Information')}
        message={t('MaximumExportLimit', {
          limit: formatNumberWithCommas(EXPORT_LIMIT, 0),
        })}
        show={exportProductInformationModal}
        onConfirmClick={async (values: ExportRange) => {
          dispatch(setProductExportFilters(values));
          await fetchExportProductsInformation(values);
        }}
        onCloseClick={() => setExportProductInformationModal(false)}
        totalData={productTotal}
        cancelBtnMsg={t('Cancel')}
        confirmBtnMsg={t('Confirm')}
        type={1}
      />
      <ProductQuantityExportModal
        title={t('Quantity')}
        message={t('MaximumExportLimit', {
          limit: formatNumberWithCommas(EXPORT_LIMIT, 0),
        })}
        show={exportProductQuantityModal}
        onConfirmClick={async (values: ExportRange) => {
          dispatch(setProductExportFilters(values));
          await fetchExportProductsQuantity(values);
        }}
        onCloseClick={() => setExportProductQuantityModal(false)}
        totalData={productTotal}
        cancelBtnMsg={t('Cancel')}
        confirmBtnMsg={t('Confirm')}
      />
      <Container fluid>
        <BreadCrumb title={t('Items List')} pageTitle={t('Items')} />
        <Row>
          <Col lg={12}>
            <Card id="itemsList">
              <CardHeader className="card-header border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">{t('Search Items')}</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      {/* <button
                        type="button"
                        className="btn btn-soft-success add-btn"
                        id="add-product-btn"
                        onClick={() => {
                          history(`${productURI}/add`);
                        }}
                      >
          
                        <MdOutlineAdd fontSize={ProductListButtonIconSize} />
                        {t('Btn_CreateProduct')}
                      </button> */}
                      <MainAddButton
                        to={`${productURI}/add`}
                        label={t('Btn_CreateProduct')}
                        id="add-product-btn"
                        soft={true}
                      />{' '}
                      {/* <button
                        type="button"
                        className="btn btn-info"
                        onClick={() => setIsExportCSV(true)}
                      >
                        <i className="ri-file-download-line align-bottom me-1"></i>{' '}
                        Export
                      </button>{' '} */}
                      <ExportButton
                        _limitData={productTotal * PageFilters.branch.length}
                        toggleExportInformationModal={
                          setExportProductInformationModal
                        }
                        toggleExportQuantityModal={
                          setExportProductQuantityModal
                        }
                      />
                      <button
                        type="button"
                        className="btn btn-soft-dark d-flex align-items-center"
                        onClick={() => {
                          window.open(
                            appendPathToClientUrl(
                              process.env.REACT_APP_OLD_PAGE,
                              'items/import_csv_items_list'
                            ),
                            '_blank'
                          );
                        }}
                      >
                        <MdMoveToInbox
                          // size={14}
                          size={ProductListButtonIconSize}
                          className="align-center mx-1"
                        />
                        {t('Import')}
                      </button>
                      {isMultiDeleteButton && (
                        // <button
                        //   // className="btn btn-soft-danger"
                        //   className="btn btn-soft-danger d-flex align-items-center"
                        //   data-testid="multi-delete-button"
                        //   onClick={() => setDeleteModalMulti(true)}
                        // >
                        //   {/* <i className="ri-delete-bin-2-line"></i> */}
                        //   <RiDeleteBin2Line
                        //     size={ProductListButtonIconSize}
                        //     className="align-center mx-1"
                        //   />
                        //   {t('Delete')}
                        // </button>
                        <MainDeleteButton
                          onClick={() => setDeleteModalMulti(true)}
                          iconSize={ProductListButtonIconSize}
                        />
                      )}
                    </div>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="border border-dashed border-end-0 border-start-0 mb-3">
                <ProductSearchForm
                  isDarkMode={isDarkMode}
                  isAdvanceSearch={isAdvanceSearch ? isAdvanceSearch : false}
                  branchesIds={branchesIds}
                  setIsAdvanceSearch={setIsAdvanceSearch}
                  onSubmit={handleProductSearchSubmit}
                  onSearchItemIdsChange={setLatestSearchItemIds}
                  skipInitialSearchFetch={shouldHydrateFromCache}
                />
                {selectedCheckBoxDelete && selectedCheckBoxDelete.length > 0 ? (
                  <TextSelectedItems
                    selectedItems={selectedCheckBoxDelete.length}
                  />
                ) : null}
              </CardBody>

              <CardBody className="pt-0">
                <div>
                  {/* {isLoadSuccess ? (
                    <TableContainerPOS2U
                      columns={ProductColumns}
                      data={productList || []}
                      // data={rowProducts || []}
                      customPageSize={PageDetails.entriesPerPage}
                      divClass="table-responsive table-card mb-1 mt-0"
                      tableClass="align-middle table-nowrap"
                      theadClass={`table-${
                        isDarkMode ? 'dark' : 'light'
                      } text-muted text-uppercase`}
                      selectedCheckBoxDelete={selectedCheckBoxDelete.length}
                      TotalData={productTotal}
                      totalPages={totalPages}
                      setEntriesPerPage={setEntriesPerPage}
                      currentPage={PageDetails.currentPage}
                      handlePageChange={handlePageChange}
                      handleSearchFiltersSubmit={handleProductSearchSubmit}
                      // isProductQuery={true}
                      inputPageValue={PageDetails.inputPageValue}
                      setInputPageValue={setInputPageValue}
                      // isAdvanceSearch={isAdvanceSearch}
                      // setIsAdvanceSearch={setIsAdvanceSearch}
                    />

                  ) : (
                    <Loader />
                  )} */}
                  <TableWrapper
                    columns={ProductColumns}
                    data={productList || []}
                    // data={rowProducts || []}
                    customPageSize={PageDetails.entriesPerPage}
                    divClass="table-responsive table-card mb-1 mt-0"
                    tableClass="align-middle table-nowrap"
                    theadClass={`table-${
                      isDarkMode ? 'dark' : 'light'
                    } text-muted text-uppercase`}
                    TotalData={productTotal}
                    totalPages={totalPages}
                    setEntriesPerPage={setEntriesPerPage}
                    currentPage={PageDetails.currentPage}
                    handlePageChange={handlePageChange}
                    // isProductQuery={true}
                    inputPageValue={PageDetails.inputPageValue}
                    setInputPageValue={setInputPageValue}
                    isTableLoadSuccess={isLoadSuccess}
                    // isAdvanceSearch={isAdvanceSearch}
                    // setIsAdvanceSearch={setIsAdvanceSearch}
                  />
                </div>
                <ToastContainer closeButton={false} limit={1} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <PricesModal
        fetchAllProducts={fetchAllProducts}
        // productList={productList}
        // setProductList={setProductList}
      />
      <InventoryModal fetchAllProducts={fetchAllProducts} />
      <InventoryDetailsModal _fetchAllProducts={fetchAllProducts} />
      <LoaderModal
        isOpen={isLoaderModalOpen}
        error={loaderError}
        onClose={() => setIsLoaderModalOpen(false)}
      />
    </div>
  );
};

export default ItemsPage;
